import { FC } from 'react'
import { NewHeader as PageHeader } from 'components/page-header'
import { useTranslation } from 'react-i18next'
import { MenuButton } from 'components/buttons'
import { ReportStatusCharm } from '../report-charm/ReportStatusCharm'
import { ReportApiAccessActiveCharm } from '../report-charm/ReportApiAccessActiveCharm'
import {
  faPenToSquare,
  faTrashCan,
  faFloppyDisks,
  faFloppyDisk,
  faChartNetwork,
} from '@fortawesome/pro-regular-svg-icons'

interface Props {
  apiAccessActive: boolean
  canEdit: boolean
  canManageApiAccess: boolean
  canSave: boolean
  dirty: boolean
  favorite?: boolean
  hideManageApiAccess?: boolean
  isPublic: boolean
  italicizeTitle?: boolean
  onDelete: () => void
  onEdit: () => void
  onFavoriteChange?: (isFavorite: boolean) => void
  onManageApiAccess: () => void
  onSave: () => void
  onSaveAs: () => void
  title: string
}

export const Header: FC<Props> = ({
  apiAccessActive,
  canEdit,
  canManageApiAccess,
  canSave,
  dirty,
  hideManageApiAccess = false,
  isPublic,
  italicizeTitle,
  onDelete,
  onEdit,
  onManageApiAccess,
  onSave,
  onSaveAs,
  title,
}) => {
  const { t } = useTranslation()

  return (
    <PageHeader
      title={title}
      italicizeTitle={italicizeTitle}
      renderTitleSlot={() => {
        if (dirty)
          return (
            <span className="px-1 text-xs rounded bg-neutral-300 text-neutral-900">
              Unsaved
            </span>
          )

        /*
        return (
          <IconButton
            className={twMerge(
              favorite ? 'text-warning-500' : 'text-neutral-900',
            )}
            icon={favorite ? faStar : faStarOutlined}
            onClick={() => onFavoriteChange(!favorite)}
          />
        )
        */
      }}
      renderRightSlot={() => {
        return (
          <>
            <ReportStatusCharm status={isPublic ? 'public' : 'private'} />
            {apiAccessActive && <ReportApiAccessActiveCharm />}
            <MenuButton
              className="ml-2"
              title={t('common.action')}
              menuItems={[
                {
                  icon: faFloppyDisk,
                  label: t('common.save'),
                  onClick: onSave,
                  disabled: !canSave || !dirty,
                },
                {
                  icon: faFloppyDisks,
                  label: t('common.saveAs'),
                  onClick: onSaveAs,
                },
                !hideManageApiAccess && {
                  icon: faChartNetwork,
                  label: t('features.reporting.manageApiAccess'),
                  onClick: onManageApiAccess,
                  disabled: !canManageApiAccess || dirty,
                  tooltip:
                    canManageApiAccess && dirty
                      ? t(
                          'features.reporting.managingAccessRequiresThatTheReportIsSavedAndUnchanged',
                        )
                      : undefined,
                },
                {
                  icon: faPenToSquare,
                  label: t('common.edit'),
                  onClick: onEdit,
                  disabled: !canEdit,
                },
                {
                  icon: faTrashCan,
                  label: t('common.delete'),
                  onClick: onDelete,
                  disabled: !canEdit,
                },
                // {
                //   content: (
                //     <>
                //       <FontAwesomeIcon icon={faPenToSquare} className="mr-2" />
                //       {t('common.saveAs')}
                //     </>
                //   ),
                //   onClick: handleSaveAsClick,
                //   disabled: !isPublic,
                // },
                // TODO: Share link
              ]}
            >
              {t('common.action')}
            </MenuButton>
          </>
        )
      }}
    />
  )
}
